// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.modalCard[data-v-2ad55c40] {\n  max-width: 600px;\n}\n.main[data-v-2ad55c40] {\n  background-color: #1e1e1e;\n}\n", ""]);
// Exports
module.exports = exports;
